import * as React from 'react'
import { Eye, X } from '@phosphor-icons/react'

export type AttachmentDisplayProps = {
  attachments: Array<{
    id: string
    filename: string
    contentType?: string
    url?: string
    uploadedByUserName?: string
    uploadedByUserId?: string | number
  }>
  showRemove?: boolean
  onRemove?: (id: string) => void
  currentUserId?: string | number
  existingAttachmentIds?: string[]
  showUploaderLabel?: boolean
}

export const AttachmentDisplay: React.FC<AttachmentDisplayProps> = ({
  attachments,
  showRemove = false,
  onRemove,
  currentUserId,
  existingAttachmentIds: _existingAttachmentIds,
  showUploaderLabel = true,
}) => {
  if (!attachments || attachments.length === 0) {
    return null
  }

  return (
    <div className="mt-1 flex flex-wrap gap-2">
      {attachments.map((attachment, index) => {
        const url = attachment?.url
        const filename = attachment?.filename?.toString()
        const uploaderName = attachment?.uploadedByUserName
        const isCurrentUser =
          attachment?.uploadedByUserId != null &&
          String(attachment?.uploadedByUserId) === String(currentUserId)

        const displayName = uploaderName
          ? isCurrentUser
            ? 'You'
            : uploaderName
          : null

        return (
          <div
            key={attachment?.id || index}
            className="flex items-center gap-1 rounded-md bg-gray-100 px-2 py-0.5 text-xs"
          >
            <div className="flex min-w-0 flex-col">
              <span
                className="truncate max-w-48 text-gray-700"
                title={filename}
              >
                {filename}
              </span>
              {showUploaderLabel && displayName && (
                <span className="text-gray-500 text-[10px]">
                  uploaded by {displayName}
                </span>
              )}
            </div>
            {url && (
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="shrink-0 text-blue-600 hover:text-blue-800"
              >
                <Eye aria-hidden className="w-3 h-3" weight="bold" />
              </a>
            )}
            {showRemove && onRemove && attachment?.id && (
              <button
                type="button"
                onClick={() => onRemove(attachment.id)}
                className="shrink-0 text-gray-600 hover:text-gray-800 ml-1"
                title="Remove attachment"
              >
                <X className="w-3 h-3" weight="bold" />
              </button>
            )}
          </div>
        )
      })}
    </div>
  )
}
